import { action, payload } from 'ts-action'
import { IError, IPayload } from 'models/Global'
import { ICity } from 'models/City'

export const GetCities = action('GetCities', payload<IPayload<ICity[]>>())
export const UpdateCity = action('UpdateCity', payload<IPayload<ICity>>())
export const GetCitiesErrors = action('GetCitiesErrors', payload<IError>())
export const CitiesFetching = action('CitiesFetching', payload<boolean>())
